"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Introduction = _interopRequireDefault(require("./Introduction"));
var _GeralInformations = _interopRequireDefault(require("./GeralInformations"));
var _UserRights = _interopRequireDefault(require("./UserRights"));
var _CollectedInformation = _interopRequireDefault(require("./CollectedInformation"));
var _DataProcessing = _interopRequireDefault(require("./DataProcessing"));
var _PolicyChange = _interopRequireDefault(require("./PolicyChange"));
var _DataStorage = _interopRequireDefault(require("./DataStorage"));
var _ApplicableLaw = _interopRequireDefault(require("./ApplicableLaw"));
/**
 * @param {{
 *     emailDomain: string;
 * }} props
 */
function Information(_ref) {
  var emailDomain = _ref.emailDomain;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Introduction["default"], null), /*#__PURE__*/_react["default"].createElement(_GeralInformations["default"], null), /*#__PURE__*/_react["default"].createElement(_UserRights["default"], null), /*#__PURE__*/_react["default"].createElement(_CollectedInformation["default"], {
    emailDomain: emailDomain
  }), /*#__PURE__*/_react["default"].createElement(_DataProcessing["default"], {
    emailDomain: emailDomain
  }), /*#__PURE__*/_react["default"].createElement(_PolicyChange["default"], null), /*#__PURE__*/_react["default"].createElement(_DataStorage["default"], null), /*#__PURE__*/_react["default"].createElement(_ApplicableLaw["default"], null));
}
var _default = Information;
exports["default"] = _default;